import { ChangeLang } from '../../../container/slices/LangSlice';
import { menuPH } from '../../../container/slices/MenuSlice';


// changelanguage Dispatch of site

export const lang = (dis) => {
	dis(ChangeLang());
};

export const menu = (e) => {
	e(menuPH());
};